<script>
    import CallToAction from "./routes/home/call2action.svelte";
    import CardBody from "./routes/home/cards/cardBody.svelte";
    import CardSelector from "./routes/home/cards/cardSelector.svelte";
    import FinalCall from "./routes/home/finalCall.svelte";
    import Footer from "./routes/home/footer.svelte";
    import Hero from "./routes/home/hero.svelte";
    import Video from "./routes/home/Video.svelte";
    let scrollHeight, width, height;
    import { screenStore } from "./functions/stores.js";
    import { onMount } from "svelte";
    import About from "./routes/home/about.svelte";
    import Blog from "./routes/blogs/blog.svelte";
    onMount((e) => {
        screenStore.update((e) => {
            return { scrollHeight, width, height };
        });
    });
    let y;
    let page='home';
</script>

<Hero bind:page bind:y/>
{#if page=='home'}
<div class="space-y-2">
    <Video />
    <CallToAction />
</div>
<CardBody />

<FinalCall />
<About />
{:else if page=='blogs'}
<Blog />
{/if}
<Footer bind:y />
<svelte:window
    bind:scrollY={y}
    bind:innerWidth={width}
    bind:innerHeight={height}
/>

<style>
</style>
